import { useMutation, useQueryClient } from 'react-query';
import { loan_request } from '@axo/shared/data-access/types';
import { loan_quote_api } from '@axo/shared/data-access/api';
import { applicationKeys } from '../cache-keys/applicationKeys';
import { useAPI } from '@axo/shared/data-access/provider';

interface IUseUpdateLoanRequest {
  loanRequests: loan_request.CreateLoanRequest[];
}

export function useRegisterLoanRequests(applicationID: string) {
  const client = useQueryClient();
  const api = useAPI();

  return useMutation(
    ({ loanRequests }: IUseUpdateLoanRequest) =>
      Promise.all(loanRequests.map(loan_quote_api.registerLoanRequest(api))),

    {
      onSuccess: () => {
        const cacheKeys = [
          applicationKeys.loanRequest({ applicationID }),
          applicationKeys.loanQuotes({ applicationID }),
        ];
        return Promise.all(
          cacheKeys.map((cacheKey) => client.invalidateQueries(cacheKey)),
        );
      },
    },
  );
}
